// extracted by mini-css-extract-plugin
module.exports = {"header":"ja","whiteTheme":"jb","blackNav":"jc"};